import React from 'react';

const Logout = () => (
  <div className="text-center">
    {/* <LogoutContent /> */}
  </div>
);

export default Logout;
